const globalMeta = {
    mainNavEnabled: false,
    topBarEnabled: true,
}
export default [
 
    {
        path: 'home',
        name: 'Home',
        component: () => import(/* webpackChunkName: "sds" */ '../views/Home.vue'),
        meta: globalMeta,
    },
    {
        path : 'result',
        name: 'Result',
        component: () => import(/* webpackChunkName: "sds" */ '../views/Result.vue'),
        meta: globalMeta,
    }
    
]
